var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndiegamesplus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-0.5 -0.5 33 25",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 8.00,0.00 C 8.00,0.00 16.00,0.00 16.00,0.00 16.00,0.00 16.00,8.00 16.00,8.00 16.00,8.00 22.00,8.00 22.00,8.00 22.00,8.00 22.00,12.00 22.00,12.00 22.00,12.01 23.99,12.00 24.00,12.00 24.00,12.00 24.00,16.00 24.00,16.00 24.00,16.00 20.00,15.98 20.00,15.98 20.01,15.98 20.00,14.00 20.00,14.00 20.00,14.00 18.00,14.00 18.00,14.00 18.00,14.00 18.00,16.00 18.00,16.00 18.00,15.99 16.00,16.01 16.00,16.00 16.00,16.00 16.00,24.00 16.00,24.00 16.00,24.00 8.00,24.00 8.00,24.00 8.00,24.00 8.00,16.00 8.00,16.00 8.00,16.00 0.00,16.00 0.00,16.00 0.00,16.00 0.00,8.00 0.00,8.00 0.00,8.00 8.00,8.00 8.00,8.00 8.00,8.00 8.00,0.00 8.00,0.00 Z M 25.00,8.00 C 25.00,8.00 29.00,8.00 29.00,8.00 29.00,8.00 29.00,12.00 29.00,12.00 29.00,12.00 25.00,12.00 25.00,12.00 25.00,12.00 25.00,8.00 25.00,8.00 Z M 30.00,12.00 C 30.00,12.00 30.00,14.00 30.00,14.00 30.00,14.00 32.00,13.99 32.00,13.99 32.00,13.99 32.00,11.99 32.00,11.99"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndiegamesplus);
export default __webpack_public_path__ + "static/media/indiegamesplus.b7a6cb7f5ab7127d152f86334a5c547e.svg";
export { ForwardRef as ReactComponent };